import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import uiSelectors from 'store/selectors/ui'

function Theme(props) {
  const color = useSelector(uiSelectors.color)
    
  const theme = useMemo(() => {

    const theme = {
      palette: {
        
      }
    }

    if(color) {
      theme.palette.primary = {
        main: color.color,
      }
    }

    return createMuiTheme(theme)
  }, [
    color,
  ])

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      { props.children }
    </MuiThemeProvider>
  );
}

export default Theme